import {BASE_API_URL} from '../constants'
import Token from "./Token";


export const UserVehicleApi = {
    get: () => {
        return fetch(
            BASE_API_URL + '/api/user-vehicle',
            {
                method: 'GET',
                headers: {
                    Authorization: 'Bearer ' + Token.getToken()
                }
            },
        ).then(r => {
            if (r.ok) {
                return r.json()
            }
            throw new Error(r.statusText)
        })
    },
    post: (vehicleData) => {
        return fetch(BASE_API_URL + '/api/user-vehicle', {
            method: 'POST',
            headers: {
                Authorization: 'Bearer ' + Token.getToken(),
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(vehicleData),
        }).then(r => {
            if (r.ok) {
                return r.json()
            }
            throw new Error(r.statusText)
        })
    },
    put: (userVehicleUuid, vehicleData) => {
        let url = BASE_API_URL + '/api/user-vehicle/' + userVehicleUuid
        return fetch(url, {
            method: 'PUT',
            headers: {
                Authorization: 'Bearer ' + Token.getToken(),
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(vehicleData),
        }).then(r => {
            if (r.ok) {
                return r.json()
            }
            throw new Error(r.statusText)
        })
    }
}